"use client";
import { Button, Input, createStyles } from "@mantine/core";
import { ArrowLeft, ArrowRight } from "../Svg";
import t from "@/lib/localization";
import { usePathname } from "next/navigation";
import Link from "next/link";

const useStyles = createStyles((theme) => ({
  title: {
    fontSize: "16px",
    lineHeight: "24px",
    color: "#5C5C5C",
    fontWeight: "400",
  },
  button: {
    height: "40px",
    width: "108px",
    alignItems: "center",
  },
  input: {
    textAlign: "center",
    marginRight: "16px",
    height: 32,
  },
}));

const CPaginationWithLinks = ({
  value = 1,
  totalPages = 0,
  dictionary = {},
  className,
  searchItems,
}) => {
  const { classes } = useStyles();
  const pathName = usePathname();
  return (
    <section className={`my-8 ${className}`}>
      <div className="flex justify-end">
        <div className="flex flex-wrap items-center">
          <h3 className={`${classes.title} m-0 mr-[16px]`}>
            {dictionary.page}
          </h3>
          <Input
            readOnly
            value={value}
            aria-label="Page"
            // onChange={handleInputChange}
            style={{
              width: "80px",
              minWidth: `${value.length * 20}px`,
              height: "32px",
              marginRight: "16px",
            }}
            classNames={{ input: classes.input }}
          />
          <h3 className={`${classes.title} m-0 mr-[16px]`}>
            {t(dictionary.ofCount, { count: totalPages })}
          </h3>
          <Button.Group className={`${classes.button}`}>
            <Link
              href={`${pathName.split("/page")[0]}/page/${
                value > 1 ? value - 1 : value
              }?${Object.entries(searchItems)
                .filter((item) => item[1] && item[0] != "page")
                .map((item) => {
                  return Array.isArray(item[1])
                    ? item[1].map((item2) => `${item[0]}=${item2}&`).join("")
                    : `${item[0]}=${item[1]}&`;
                })
                .join("")}`}
              scroll={false}
            >
              <Button
                aria-label={"prev"}
                variant="default"
                className="border-none bg-primaryOpacity hover:bg-primaryOpacity pr-2"
                // onClick={prev}
              >
                <ArrowLeft height="13px" width="26px" color="#2BADE3" />
              </Button>
            </Link>
            <Link
              href={`${pathName.split("/page")[0]}/page/${
                value < totalPages ? value + 1 : value
              }?${Object.entries(searchItems)
                .filter((item) => item[1] && item[0] != "page")
                .map((item) => {
                  return Array.isArray(item[1])
                    ? item[1].map((item2) => `${item[0]}=${item2}&`).join("")
                    : `${item[0]}=${item[1]}&`;
                })
                .join("")}`}
              scroll={false}
            >
              <Button
                aria-label={"next"}
                variant="default"
                className="border-none bg-primaryOpacity hover:bg-primaryOpacity pl-2"
                // onClick={next}
              >
                <ArrowRight height="13px" width="26px" color="#2BADE3" />
              </Button>
            </Link>
          </Button.Group>
        </div>
      </div>
    </section>
  );
};

export default CPaginationWithLinks;
